import { render } from "./HowItWork.vue?vue&type=template&id=577cc43b&scoped=true"
import script from "./HowItWork.vue?vue&type=script&lang=js"
export * from "./HowItWork.vue?vue&type=script&lang=js"

import "./HowItWork.vue?vue&type=style&index=0&id=577cc43b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\market\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577cc43b"]])

export default __exports__